import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CampaignsProvider }  from '@providers/campaigns/campaigns';
import { TabsPage } from '@pages';

@IonicPage()
@Component({
  selector: 'page-nueva-campania',
  templateUrl: 'nueva-campania.html',
})
export class NuevaCampaniaPage {

  campania: any;

  constructor(
    private campaignsProvider: CampaignsProvider,
    public navCtrl: NavController,
    public navParams: NavParams) {
      this.campania = navParams.get('campania');
  }

  ionViewDidLoad() {

  }

  close() {
    this.campaignsProvider.hideModal();
    this.navCtrl.setRoot(TabsPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/nueva-campania/nueva-campania.ts